module.exports = "data:image/svg+xml;base64,PHN2ZyBpZD0iTGF5ZXJfMSIgZGF0YS1uYW1lPSJMYXllciAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxNSAxNSI+PHRpdGxlPk9mZmVyXzQ8L3RpdGxlPjxwYXRoIGQ9Ik0xNC41LDExLjY4djMuMUg0LjY3VjEyLjQ3TDEsOC43OGExLjM3LDEuMzcsMCwwLDEtLjItLjI2QTEuMzMsMS4zMywwLDAsMSwuNSw3LjdWMS41MUExLjM1LDEuMzUsMCwwLDEsMS44NS4xN2guMjlBMS4zNSwxLjM1LDAsMCwxLDMuNDgsMS41MVY3TDYuMTcsOS42NWg2LjY3QTEuODksMS44OSwwLDAsMSwxNC41LDExLjY4WiIvPjxjaXJjbGUgY3g9IjkuNzMiIGN5PSI1LjE2IiByPSIzLjYxIi8+PC9zdmc+"


//////////////////
// WEBPACK FOOTER
// ./src/img/offer.svg
// module id = 831
// module chunks = 0